import script from "./TemplateThumb.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateThumb.vue?vue&type=script&setup=true&lang=js"

import "./TemplateThumb.vue?vue&type=style&index=0&id=b3fce946&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3fce946"]])

export default __exports__